import axios from 'axios';
import Cookies from 'js-cookie';
import { ezResourceGrid } from 'ez-styles/assets/javascripts/ez-styles/justified-grid';
import { triggerCustomEvent, parseTemplate } from 'lib/helpers';

export default class SSTKAPI {
  constructor(container, term) {
    this.container = container;

    this.searchTerm = term;

    // Hardcoded hotfix to use old results api
    this.apiUrl = 'https://sstk.xeezy.com/api/shutterstock_images';

    this.mobileTag = document.body.classList.contains('is-mobile') ? '|mobile' : '';

    this.gridContainer = container.querySelector('.ez-resource-grid');

    this.setupResultTemplate();
  }

  setupResultTemplate() {
    this.defaultResultTemplate = `
      <li class="ez-resource-grid__item ez-resource-thumb" data-w="{{image_width}}" data-h="{{image_height}}">
        <a class="ez-resource-thumb__link" title="{{description}}" target="_new" href="{{url}}">
          <img class="ez-resource-thumb__img" src="{{image_src}}" alt="{{description}}" />
        </a>
      </li>
      `;

    // get template element, if a custom one exists
    this.customResultTemplateElem = document.querySelector('[data-target="sstk-api.resultTemplate"]');

    if (this.customResultTemplateElem) {
      // save template html to variable
      this.resultTemplate = document.querySelector('[data-target="sstk-api.resultTemplate"]').innerHTML;
      // now that we have the custom template html, remove the template element (because IE is stupid)
      this.customResultTemplateElem.parentNode.removeChild(this.customResultTemplateElem);
    } else {
      this.resultTemplate = this.defaultResultTemplate;
    }

    if (this.resultTemplate.indexOf('data-src') !== -1) {
      this.srcAttr = 'data-src';
    } else if (this.resultTemplate.indexOf('data-lazy-src') !== -1) {
      this.srcAttr = 'data-lazy-src';
    } else {
      this.srcAttr = 'src';
    }
  }

  renderResults = (results, options) => {
    if (options.controllerElem.classList.contains('is-hidden')) {
      options.controllerElem.classList.remove('is-hidden');
    }

    const loc = options.loc || 'en';

    const images = results.data;

    images.forEach((image, index, array) => {
      const item = image;
      const itemThumb = options.largeThumb ? 'preview' : 'large_thumb';

      const picUrl = encodeURIComponent(`http://www.shutterstock.com/${loc}/pic.mhtml?id=${item.id}`);

      item.url = `http://shutterstock.7eer.net/c/${options.ird}/111120/1305?u=${picUrl}`;
      item.image_src = item.assets[itemThumb].url;
      item.image_height = item.assets[itemThumb].height;
      item.image_width = item.assets[itemThumb].width;

      if (options.urlparams) {
        item.url += `&${options.urlparams}|${item.id}${this.mobileTag}`;
      }

      if ((parseInt(item.image_height, 10) / parseInt(item.image_width, 10)) > 0.45) {
        const itemHTML = parseTemplate(this.resultTemplate, item);

        this.gridContainer.insertAdjacentHTML('beforeend', itemHTML);

        if (this.container.classList.contains('sstk-results--old-grid')) {
          const thisImg = this.gridContainer.querySelector(`img[${this.srcAttr}="${item.image_src}"]`);

          this.getOrigImageDimensions(thisImg, (d) => {
            thisImg.setAttribute('data-orig-width', d.width);
            thisImg.setAttribute('data-orig-height', d.height);

            this.hideSSTKID(thisImg, item.image_width, item.image_height);
          });
        }
      }

      // After last image in set, run/re-run the justified grid script
      if (index === array.length - 1) {
        this.gridContainer.classList.remove('is-hidden');

        ezResourceGrid(this.gridContainer, {
          rowHeight: options.rowHeight || 70,
          maxRows: parseInt(options.maxRows, 10) || null,
        });
      }
    });
  }

  getOrigImageDimensions = (el, onReady) => {
    const defaultSrc = el.getAttribute(this.srcAttr) !== undefined ? el.getAttribute(this.srcAttr) : el;
    const src = typeof el.attr === 'function' ? el.attr(this.srcAttr) : defaultSrc;

    const image = new Image();

    image.onload = () => {
      if (typeof (onReady) === 'function') {
        onReady({
          width: image.width,
          height: image.height,
        });
      }
    };

    image.src = src;
  }

  makeAspectRatio = (targetWidth, targetHeight) => (targetHeight / targetWidth) * 100

  hideSSTKID = (image, targetWidth, targetHeight) => {
    const linkWrap = image.closest('.ez-resource-thumb__link');
    const aspectRatio = this.makeAspectRatio(targetWidth, targetHeight);

    linkWrap.style.paddingBottom = `${aspectRatio}%`;

    const img = image;

    const actualImgWidth = parseInt(image.getAttribute('data-orig-width'), 10);
    const actualImgHeight = parseInt(image.getAttribute('data-orig-height'), 10);

    const widthDiff = actualImgWidth - targetWidth;
    const heightDiff = actualImgHeight - targetHeight;

    img.style.width = `${100 + this.calcDiffPercentage(widthDiff, actualImgWidth)}%`;
    img.style.height = `${100 + this.calcDiffPercentage(heightDiff, actualImgHeight)}%`;

    img.style.maxHeight = `calc(110px + ${this.calcDiffPercentage(heightDiff, actualImgHeight)}%)`;
  }

  calcDiffPercentage(diff, origVal) {
    if (diff > 0) {
      return (diff / origVal) * 100;
    }
    return 0;
  }

  generateUrl = (options) => {
    let url = this.apiUrl;

    if (this.container.hasAttribute('data-resource-id')) {
      // TODO: Set up new api endpoint for related sstk results
      // return `/api/shutterstock_images/${this.container.getAttribute("data-resource-id")}/related_image_search`;
    }

    if (typeof (this.searchTerm) === 'undefined' || !this.searchTerm) {
      const searchField = document.querySelector('[data-target="search-form.input"]');
      this.searchTerm = searchField.value;
    }

    url += `/${encodeURI(this.searchTerm)}?`;

    const resultsLimit = typeof options.limit !== 'undefined' ? options.limit : 80;

    url += `&per_page=${resultsLimit}`;

    if (options.page) {
      url += `&page=${(parseInt(options.page, 10) + 1)}`; // api uses 1 based index
    } else {
      url += '&page=1';
    }

    // Intentionally using abstract equality operator
    // to check for null AND undefined
    if (options.padResults != null) {
      url += `&pad_images=${options.padResults}`;
    }

    if (options.apiparams) {
      url += `&${options.apiparams}`;
    }
    return url;
  }

  makeUrlParams(sstkSharedId, sstkSubId1, sstkSubId2) {
    return `sharedid=${sstkSharedId}&subId1=${sstkSubId1}`
            + `&subId2=${encodeURI(sstkSubId2)}`
            + `&subId3=${Cookies.get('ga-client-id')}${this.mobileTag}`;
  }

  getResults(options) {
    const url = this.generateUrl(options);

    axios.get(url)
      .then((response) => {
        if (response.data) {
          if (response.data.total_count) {
            if (!this.container.hasAttribute('data-total-count')) {
              this.container.setAttribute('data-total-count', response.data.total_count);
            }

            this.renderResults(response.data, options);

            triggerCustomEvent('resultsLoaded');
          } else {
            triggerCustomEvent('resultsLoaded', 'END_OF_RESULTS');
          }
        }
      });
  }
}
